'use client';

import { useCallback, useState } from 'react';

import { AI_TABS, AiCategory, sectionMap } from '@fe-news/constants/ai/type';
import AsideSection from '../AsideSection/AsideSection';
import AsideAiNewsContent from './AsideAiNewsContent';
import { CustomEventName, GTMEventKey, sendGTM } from '@fe-cnyes/fe-common-gtm';

type AsideAiNewsProps = {
  isAiGc?: boolean;
};

const AsideAiNews = ({ isAiGc = false }: AsideAiNewsProps) => {
  const [tab, setTab] = useState<
    AiCategory.AIGC_HOT | AiCategory.HEADLINE_AI | AiCategory.TW_STOCK_AI | AiCategory.WD_STOCK_AI
  >(AiCategory.AIGC_HOT);

  const onChangeTab = useCallback((category: string | number) => {
    setTab(category as AiCategory.AIGC_HOT | AiCategory.HEADLINE_AI | AiCategory.TW_STOCK_AI | AiCategory.WD_STOCK_AI);
    sendGTM({
      [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_TAB,
      [GTMEventKey.SECTION]:
        sectionMap[
          category as AiCategory.AIGC_HOT | AiCategory.HEADLINE_AI | AiCategory.TW_STOCK_AI | AiCategory.WD_STOCK_AI
        ],
      [GTMEventKey.CLICK_ITEM]: AI_TABS.find(tab => tab.category === category)?.name
    });
  }, []);

  const url =
    tab === AiCategory.WD_STOCK_AI
      ? `/news/cat/wd_stock_ai`
      : tab === AiCategory.TW_STOCK_AI
        ? `/news/cat/tw_stock_ai`
        : tab === AiCategory.AIGC_HOT
          ? `/news/cat/hotai`
          : `/news/cat/headline_ai`;

  return (
    <AsideSection title='鉅亨熱AI' icon='/assets/icons/icon-ai.svg' readMoreLink={url}>
      <AsideAiNewsContent isAiGc={isAiGc} tab={tab} onChangeTab={onChangeTab} url={url} />
    </AsideSection>
  );
};

export default AsideAiNews;
